import { createSelector } from '@ngrx/store';
import { acabadoAdapter, colorMaterialAdapter, continenteAdapter, disponibilidadAdapter, espesorAdapter, materialAdapater, ModuleState, rangoPrecioAdapter, stockAdapter, tipoMaterialAdapter, usoMaterialAdapter } from '../state';

export const selectMaestros = (state: ModuleState) => state.maestros;
export const selectStock = (state: ModuleState) => state.stock;
export const selectDetalles = (state: ModuleState) => state.details;

export const tipoMaterialStateSelector = createSelector(
  selectMaestros,
  state => state.tipoMaterial
)
export const acabadoStateSelector = createSelector(
  selectMaestros,
  state => state.acabado
)
export const usoMaterialStateSelector = createSelector(
  selectMaestros,
  state => state.usoMaterial
)
export const continenteStateSelector = createSelector(
  selectMaestros,
  state => state.continente
)
export const colorMaterialStateSelector = createSelector(
  selectMaestros,
  state => state.colorMaterial
)
export const espesorStateSelector = createSelector(
  selectMaestros,
  state => state.espesor
)
export const disponibilidadStateSelector = createSelector(
  selectMaestros,
  state => state.disponibilidad
)
export const rangoPrecioStateSelector = createSelector(
  selectMaestros,
  state => state.rangoPrecio
)
export const materialesStateSelector = createSelector(
  selectMaestros,
  state => state.materiales
)

/////////////////      ENTITY SELECTORS     /////////////////////

export const tipoMaterialSelector = tipoMaterialAdapter.getSelectors(tipoMaterialStateSelector).selectAll;
export const acabadoSelector = acabadoAdapter.getSelectors(acabadoStateSelector).selectAll;
export const usoMaterialSelector = usoMaterialAdapter.getSelectors(usoMaterialStateSelector).selectAll;
export const continenteSelector = continenteAdapter.getSelectors(continenteStateSelector).selectAll;
export const colorMaterialSelector = colorMaterialAdapter.getSelectors(colorMaterialStateSelector).selectAll;
export const espesorSelector = espesorAdapter.getSelectors(espesorStateSelector).selectAll;
export const disponibilidadSelector = disponibilidadAdapter.getSelectors(disponibilidadStateSelector).selectAll;
export const rangoPrecioSelector = rangoPrecioAdapter.getSelectors(rangoPrecioStateSelector).selectAll;
export const materialesSelector = materialAdapater.getSelectors(materialesStateSelector).selectAll;
export const maestrosSelector = state => selectMaestros(state).all

export const stockSelector = stockAdapter.getSelectors(selectStock).selectAll;

export const materialesSimilaresSelector = (state: ModuleState) => state.materialesSimilares;
